import type { RegionId } from "../../types";

export type GeographyApproach = "regions" | "countries" | "states";

export type GeographySlice = {
  approach: GeographyApproach;
  regions: RegionId[];
  countries: string[]; // country alpha2 codes
  excludedCountries: string[]; // country alpha2 codes
  states: string[]; // taxonomy state IDs
};

export const defaultGeographySlice: GeographySlice = {
  approach: "regions",
  regions: [],
  countries: [],
  excludedCountries: [],
  states: [],
};
